import {
    COUNTRY_CODE_ES,
    COUNTRY_CODE_PT,
    COUNTRY_CODE_NL,
    COUNTRY_CODE_DE,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
    COUNTRY_DOCUMENT_TYPE_PASSPORT,
} from 'constants/multiLanguage';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';

export const IMAGE_BY_COUNTRY = {
    [COUNTRY_CODE_NL]: 'ID_Nederland_B&F.svg',
    [COUNTRY_CODE_DE]: '',
    [COUNTRY_CODE_ES]: 'ID_Spain_B&F.svg',
    [COUNTRY_CODE_PT]: 'ID_Portugal_B&F.svg',
};

export const CONTENT_BY_TYPE = {
    [COUNTRY_DOCUMENT_TYPE_DNI_LABEL]: {
        image: IMAGE_BY_COUNTRY[getReferenceCodeByCountry()],
        text: 'identity-dniNeededText',
    },
    [COUNTRY_DOCUMENT_TYPE_NIE_LABEL]: {
        image: `ID_SpainNIE_B&F.svg`,
        text: 'identity-tieOrNieNeededText',
    },
    [COUNTRY_DOCUMENT_TYPE_PASSPORT]: {
        image: `ID_Passport_B&F.svg`,
        text: 'identity-passportNeededText',
    },
};
